import React from 'react'
import { useTranslation } from 'react-i18next'
import { getTextByLang } from '../../ExternalFields'
import { useStore } from '../../../StateProvider'
import styles from './style.css'

const Footer = () => {
  const { t } = useTranslation()
  const [{ whitelabel }] = useStore()
  const { whiteLabelName, whiteLabelURL, customTexts } = whitelabel

  return (
    <footer className={styles.footer}>
      <span className={`${styles.footerGroup} ${styles.footerItem}`}>
        {t('footer.copyright')}{' '}
        <a className={styles.footerItemLink} href={whiteLabelURL}>
          {getTextByLang('copyright', customTexts) || whiteLabelName}
        </a>
      </span>
    </footer>
  )
}

export default Footer
